if (window.location.pathname === "/cart") {
  function dcabBloccaMPInCartPage() {
    const inputs = document.querySelectorAll(
      "input.qty-selector[data-minima-produzione]"
    );

    inputs.forEach((input) => {
      if (input.dataset.dcabBlocked === "true") return;

      const id = input.id;
      const minus = document.querySelector(`.qty-minus[controls='${id}']`);
      const plus = document.querySelector(`.qty-plus[controls='${id}']`);

      if (!minus || !plus) return;

      // Tooltip
      const tooltipText =
        "Puoi modificare la quantità solo dalla pagina prodotto";

      function setTooltip(btn) {
        btn.disabled = true;
        btn.setAttribute("data-tooltip", tooltipText);
        btn.classList.add("dcab-tooltip");
        btn.style.cursor = "not-allowed";
      }

      // Imposta tooltip e blocco
      input.setAttribute("readonly", true);
      input.setAttribute("disabled", true);
      input.style.pointerEvents = "none";
      input.style.opacity = "0.6";

      setTooltip(minus);
      setTooltip(plus);

      input.dataset.dcabBlocked = "true";
    });
  }

  // Esegui all'avvio
  document.addEventListener("DOMContentLoaded", dcabBloccaMPInCartPage);

  // Esegui dopo ogni cambiamento DOM (es. update quantità altro prodotto)
  const cartRoot = document.querySelector("#AjaxCartForm") || document.body;
  const observer = new MutationObserver(() => {
    dcabBloccaMPInCartPage();
  });
  observer.observe(cartRoot, { childList: true, subtree: true });
}
